import { __assign } from "tslib";
// DS: i7.15
import React from 'react';
import IconWrap from '../../IconWrap';
var Underline = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M17 17a1 1 0 01.117 1.993L17 19H7a1 1 0 01-.117-1.993L7 17h10zM15.818 5c.602 0 1.091.477 1.091 1.067v3.812c0 2.908-2.11 5.102-4.909 5.102-2.798 0-4.91-2.194-4.91-5.102V6.067C7.09 5.477 7.58 5 8.183 5s1.09.477 1.09 1.067v3.812c0 1.475.938 2.968 2.728 2.968s2.727-1.493 2.727-2.968V6.067c0-.59.489-1.067 1.091-1.067z" }))));
};
Underline.displayName = 'Underline';
export default Underline;
//# sourceMappingURL=Underline.js.map